module.exports = __webpack_public_path__ + "img/inventory-empty-data.fbe8c2ea.svg";